export default "__VITE_ASSET__SPXJw$te__"